//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeeList from '~/components/fee/fee_list'
import FeeQuestions from '~/components/fee/fee_questions'
export default {
  name: 'Fee',
  components: { FeeList, FeeQuestions },
  data () {
    return {
      fee: null,
      feeGroups: null
    }
  },
  head () {
    return {
      title: this.$t('fee.feeHeadTitle')
    }
  },
  created () {
    this.getFeeGroup()
  },
  methods: {
    getFeeGroup () {
      this.$store.dispatch('axios/get', {
        url: '/user/systemFee',
        config: {
          baseURL: process.env.BASE_URL_UUID
        }
      })
        .then((resp) => {
          this.fee = resp.data.data
          this.feeGroups = this.fee.feeGroups.CRYPTO_ORDER
        })
    }
  }
}
